module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "author-blurb"
  }, [_vm._v("Ashley E. Kettering currently resides in Illinois but was born and raised in Sheboygan, Wisconsin. She is married and has a beautiful daughter and twin boys. She loves animals and has two dogs and a sassy cat. She is a high school English teacher. She graduated with honors from the University of Wisconsin-Oshkosh. She and her family enjoy traveling, swimming, and trying different foods. Mrs. Kettering is an avid reader and enjoys spending her summers at Elkhart Lake with her family and friends.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/back.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/front1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "copyright ParaOverride-1"
  }, [_vm._v("Copyright © Ashley E. Kettering 2024")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ordering Information")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Publisher’s Cataloging-in-Publication data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("Kettering, Ashley E. ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("You Are Beautiful")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-2"
  }, [_vm._v("ISBN 9798889101598 (Paperback)"), _c('br'), _vm._v("ISBN 9798889101604 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("ISBN 9798889101611 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("Library of Congress Control Number: 2024900551")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com/us")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("Austin Macauley Publishers LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("40 Wall Street, 33rd Floor, Suite 3302 ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("New York, NY 10005")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("USA")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("mail-usa@austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("+1 (646) 5125767")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ded-1"
  }, [_vm._v("This book is dedicated to my parents, children, and husband. Thank you, Sydney, for asking the simplest question, “Mom, why do none of the characters in the books look like my friends at school?” This question inspired the book You Are Beautiful as there is a strong need for more representation of children with special needs or differences highlighted positively in children’s literature. Max, thank you for teaching me to build, make messes, and reminding me everyone goes a different way to the same destination. Jack, thank you for teaching me something new every day and lighting up when talking about anything you’ve learned. Mom and Dad thank you for always encouraging me to follow my heart and dreams. Lastly, thank you to my loving husband; you have believed in me and this book. Thank you for being my rock.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Ellie. I love to swim in the summer and make snowmen in the winter. I love cheese pizza and I don’t like to finish all my vegetables at dinner. My parents told me I was born with an extra chromosome, I have down syndrome, and I learn differently from my friends and sometimes can’t do the same things in the same way, but that is okay. I am me, and I am BEAUTIFUL!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Lucas. I love sports, especially baseball, football, and soccer. I love hot dogs and sweet potato fries. I don’t like mustard on my hot dogs! I have brown hair and brown skin which are different from my best friend, George. George has red hair and freckles and he likes mustard on his hot dogs! We are best friends, and we are BEAUTIFUL!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Jaxson. I love to study maps and I can always give my mom the best directions to get anywhere in town. I love to ride my bike with my friend Ryan. I don’t like loud noises. I sometimes get nervous. When things feel too much for me, I put on my blue headphones with lightning bolt stickers and count to 100. I have autism. I am not in the same classes as some of my friends at school but that doesn’t matter to me. I am me, and I am BEAUTIFUL!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Angela. It’s my first time at a new school in my new town. I love gym class, music class, and art class. I love art class the most; you can draw or make anything you imagine, and you don’t have to read to draw. I love books, but I can’t read the words very well; the story gets mixed up in my head. I know I learn differently than the other kids. My mom says I have language-processing disorder. I sometimes leave the classroom to take tests and work with my other teachers. I like that I can take my time in the other room while I take tests. My teacher can help me read the test so it makes sense to me. I am me, and I am BEAUTIFUL!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name was Allison, but I asked my parents and friends to call me Andy. I have very short hair and like to wear t-shirts, loose jeans, and my gym shoes. I love to wear my baseball hat of my favorite baseball team, the Chicago White Sox’s. I go fishing and hunting with my dad and cousins. When I look in the mirror, I like myself best this way. I am me, and I am BEAUTIFUL!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Matt. I am an excellent reader, and I absolutely love my favorite football team, the Chicago Bears. I am probably their number-one fan. I have cerebral palsy and I can’t walk. I use a wheelchair to get around. Sometimes it’s hard to get places or do certain things. I have an aide that helps me at school. I am in the same classes as most of my friends, and I help tutor kids who have trouble in math class. My friend Jude and I go three times a year to see the Chicago Bears. We watch every game at our favorite restaurant, Buffalo Wild Wings. I am me, and I am BEAUTIFUL.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("My name is Lucy. I am a cheerleader. I love to cheer with my team, The Wildcats, and my next favorite thing to do is play Barbies with my best friend Alex. I was born with something called vitiligo. Don’t worry; it sounds scary but it does not hurt. I just have light patches on my skin which stand out because I have dark skin. I absolutely love myself, and I am BEAUTIFUL.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "bbok-text-line-1"
  }, [_vm._v("Friends come in different shapes, sizes, and colors. Friends like different things, different tastes, and different smells. It is okay to like different things and be different, and best of all, you can still be friends, even if you like different things. You are beautiful just the way you came into this world.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "the-end"
  }, [_vm._v("The End")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b505c732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled2.vue
// module id = 57
// module chunks = 0